const path = '/ava/estagiarios-magisterio';

const endpoint = {
  main: path,
  remove: (pkpessoa) => `${path}/${pkpessoa}`,
};

export default endpoint;
